import React from "react";
import { Building2, CalendarClock, GraduationCap, Landmark, Megaphone } from "lucide-react";
import DashboardSvg from "@/assets/icons/dashboard.svg?react";
import TeachersSvg from "@/assets/icons/Vector.svg?react";
import StudentsSvg from "@/assets/icons/students.svg?react";
import ContentCreatorsSvg from "@/assets/icons/content-creator.svg?react";
import ContentStudioSvg from "@/assets/icons/content-studio.svg?react";
import PlusSvg from "@/assets/icons/Pluss.svg?react";

type IconProps = React.SVGProps<SVGSVGElement>;

function createIcon(SvgComponent: React.FC<IconProps>) {
  return React.memo(function Icon({
    className = "w-[24px] h-[24px]",
    ...props
  }: IconProps) {
    return <SvgComponent className={className} {...props} />;
  });
}

export const DashboardIcon = createIcon(DashboardSvg);
export const TeachersIcon = createIcon(TeachersSvg);
export const StudentsIcon = createIcon(StudentsSvg);
export const ContentCreatorsIcon = createIcon(ContentCreatorsSvg);
export const ContentStudioIcon = createIcon(ContentStudioSvg);
export const PlusIcon = createIcon(PlusSvg);
export const TenantsIcon = React.memo(function TenantsIcon({
  className = "w-[24px] h-[24px]",
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return <Building2 className={className} {...props} />;
});
export const InstitutionsIcon = React.memo(function InstitutionsIcon({
  className = "w-[24px] h-[24px]",
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return <Landmark className={className} {...props} />;
});
export const AnnouncementsIcon = React.memo(function AnnouncementsIcon({
  className = "w-[24px] h-[24px]",
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return <Megaphone className={className} {...props} />;
});
export const AcademicSetupIcon = React.memo(function AcademicSetupIcon({
  className = "w-[24px] h-[24px]",
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return <GraduationCap className={className} {...props} />;
});
export const TimeTableIcon = React.memo(function TimeTableIcon({
  className = "w-[24px] h-[24px]",
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return <CalendarClock className={className} {...props} />;
});
